/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".app-breadcrumb[_ngcontent-%COMP%]{height:96px;padding-top:31px;padding-bottom:42px}.app-breadcrumb[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#848285;border-bottom:1px solid #848285;padding-bottom:.5rem;font-size:1.14em;font-weight:300;cursor:pointer}.app-breadcrumb[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:active, .app-breadcrumb[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:focus, .app-breadcrumb[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{text-decoration:none;color:#141215;border-bottom:1px solid #141215}"];
export { styles as styles };
